<div class="file-uploader">
  <label class="label-text">{{ label }}</label>

  <div class="file-uploader-frame" [ngClass]="{'error': hasError}">
    <div class="file-uploader-dashed" [ngClass]="{'error': hasError}" (click)="triggerFileInput(fileInput)">
      <div class="upload-icon">
        <mat-icon fontSet="material-symbols-rounded fill">
          {{ !hasError ? 'cloud_upload' : 'error' }}
        </mat-icon>
      </div>
      <div class="upload-text">
        <span class="call-to-action">{{ 'common-components.fileUploader.selectFile' | translate
          }}</span>
      </div>
      <div class="format-text">
        {{ 'common-components.fileUploader.formatText' | translate: { acceptedFormats: acceptedFormats, maxSizeText:
        maxSizeText } }}
      </div>
    </div>

    <input #fileInput type="file" [accept]="acceptedFormats" (change)="onFileSelected($event)" style="display: none;"
      [multiple]="isMultipleFiles">

  </div>
  <div class="uploaded-files-list" *ngIf="uploadedFiles.length > 0">
    <div class="file-item" *ngFor="let file of uploadedFiles; let i = index">
      <div class="file-icon">
        <mat-icon fontSet="material-symbols-rounded fill">
          {{ file.fileTypeIcon }}
        </mat-icon>
      </div>
      <div class="file-info">
        <div class="file-name">{{ truncateFileName(file.name) }}</div>
        <div class="file-size">{{ formatFileSize(file.size) }}</div>
      </div>
      <button class="remove-button" (click)="removeFile(i)">
        <mat-icon fontSet="material-symbols-rounded fill">
          cancel
        </mat-icon>
      </button>
    </div>
  </div>

  <div class="error-message" *ngIf="hasError">
    {{ errorMessage }}
  </div>
</div>